import { v4 as uuid } from 'uuid';
import { createAction } from '@reduxjs/toolkit';
import {
    TConstructorItem,
    TIngredientType,
    TMoveData,
} from '../../utils/types';

export const moveItem = createAction<TMoveData, 'items/move_item'>(
    'items/move_item'
);
export const deleteItem = createAction<number, 'items/delete_item'>(
    'items/delete_item'
);
export const setCurrentItem = createAction<
    TIngredientType,
    'items/set_current'
>('items/set_current');
export const clearItems = createAction('items/clear');

export const addItem = createAction(
    'items/add_item',
    (item: TConstructorItem) => ({
        payload: {
            ...item,
            id: uuid(),
        },
    })
);

export type TConstructorActions =
    | ReturnType<typeof moveItem>
    | ReturnType<typeof deleteItem>
    | ReturnType<typeof setCurrentItem>
    | ReturnType<typeof clearItems>
    | ReturnType<typeof addItem>;
